import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
// import "../../../StyleSheet/MainComponent/ExitFlow/Nodue.scss";
import {
    settheNodueFormEmpEditActionDatas,
    settheNodueFormEmpretrieveActionDatas,
    settheNodueFormEmpActionDatas,
    setEmpnoduformfetchdatasempEmpTeamlistEmpEmpAction
} from "../../../../../../Redux/Slice";
import Select from "react-select";
import html2pdf from "html2pdf.js";
import BackImage from "../../../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import jsPDF from "jspdf";
import $ from "jquery";
import html2canvas from 'html2canvas';
import { store } from "../../../../../../Redux/Store";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NoDueEMP = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );
    const divRef = useRef(null);
    const state = useSelector((state) => state);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const initailState = {
        // name: "",
        // location: "",
        date_of_relieving: "",
        official_email: "",
        kt: "",
        back_up: "",
        clearance: "",
        salary_advance: "",
        other_advance: "",
        petty_cash: "",
        settle_expenses: "",
        it_doc: "",
        happy_account: "",
        laptop: "",
        card_accessories: "",
        email_id: "",
        sap_login: "",
        login_id: "",
        id_access_card: "",
        business_card: "",
        draw_key: "",
        headset: "",
        sim: "",
        stationary_items: "",
        charger_cable: "",
        medical_claim: "",
        exit_interview: "",
        resign_mail: "",
        notice_period: "",
        relevant: "",
        company_property: "",
        other_handover: "",
        // approved_date: "",
        reason_for_decline: "",
        user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
            .id

    };
    const [Datas, setDatas] = useState(initailState);
    const [formDirty, setFormDirty] = useState(false);
    const [printing, setPrinting] = useState(false);
    const [defualtVal, setDefualtVal] = useState(initailState);
    const formSubmitResponse = useSelector(
        (state) => state.ExitNodueEditCall.ExitNoDueEdit
    );
    const [EditIDs, setEditIDs] = useState("")

    const Options = [
        {
            id: 1,
            value: "yes",
            lable: "yes",
        },
        {
            id: 2,
            value: "no",
            lable: "No",
        },
        {
            id: 3,
            value: "",
            lable: "Nil",
        },
    ];

    const LanguageChange = (e) => {
        console.log(e.target.value, "values in app");
        setFormDirty(true);
        setDatas((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value == "" ? null : e.target.value,
            };
        });
    };

    const handleSubmitChanges = () => {

        if(Datas.date_of_relieving != "") { 
        if (EditIDs != null && EditIDs != "") {
            const payload = {
                id: EditIDs,
                data: Datas,
            };
            dispatch(settheNodueFormEmpEditActionDatas(payload));
            setFormDirty(false);
        }
        else {
            const payload = {
                data: Datas,
            };
            dispatch(settheNodueFormEmpActionDatas(payload));

        }
    }
     else {
        toast.error(` ${"Please select the date of relieving"} `, {
            position: toast.POSITION.TOP_RIGHT,
          });     }
    };

    useEffect(() => {
        const payload = {
            user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                .id,
        };
        dispatch(settheNodueFormEmpretrieveActionDatas(payload));
        setFormDirty(false);
    }, [formSubmitResponse]);

    useEffect(() => {
        const payload = {
            user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                .id,
        };
        dispatch(setEmpnoduformfetchdatasempEmpTeamlistEmpEmpAction(payload));
        setFormDirty(false);
    }, [formSubmitResponse]);

    // console.log(state.NodueFormFetchDatasgetFetch.noduformfetchdatasemp, "NodueFormFetchDatasgetFetch");

    useEffect(() => {
        const payload = {
            user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                .id,
        };
        dispatch(settheNodueFormEmpretrieveActionDatas(payload));
    }, []);

    // console.log(state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas, "asdoaisd NodueFormEmployeeFormRetrirveDatas",
// );

    useEffect(() => {
        if (state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas.length == 1) {
            state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas.map((item) => {
                // console.log(item, "sadoasod psaoid item",);

                setDatas({
                    ...Datas,
                    laptop: item.laptop ?? '',
                    kt: item.kt ?? '',
                    date_of_relieving: item.date_of_relieving ?? '',
                    official_email: item.official_email ?? '',
                    back_up: item.back_up ?? '',
                    clearance: item.clearance ?? '',
                    salary_advance: item.salary_advance ?? '',
                    other_advance: item.other_advance ?? '',
                    petty_cash: item.petty_cash ?? '',
                    settle_expenses: item.settle_expenses ?? '',
                    it_doc: item.it_doc ?? '',
                    happy_account: item.happy_account ?? '',
                    card_accessories: item.card_accessories ?? '',
                    email_id: item.email_id ?? '',
                    sap_login: item.sap_login ?? '',
                    login_id: item.login_id ?? '',
                    id_access_card: item.id_access_card ?? '',
                    business_card: item.business_card ?? '',
                    draw_key: item.draw_key ?? '',
                    headset:item.headset ?? '',
                    sim: item.sim ?? '',
                    stationary_items: item.stationary_items ?? '',
                    charger_cable: item.charger_cable ?? '',
                    medical_claim: item.medical_claim ?? '',
                    exit_interview: item.exit_interview ?? '',
                    resign_mail: item.resign_mail ?? '',
                    notice_period: item.notice_period ?? '',
                    relevant: item.relevant ?? '',
                    company_property: item.company_property ?? '',
                    other_handover: item.other_handover ?? '',
                    // approved_date: item.approved_date ?? '',
                    reason_for_decline: item.reason_for_decline ?? '',
                    user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                        .id
                });
                setEditIDs(item.id)

            })
        }
    }, [state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas,]);
console.log(Datas ,"asj EditIDs dsdasd");

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>

                <div
                    className="row Filters ButtonPrevious"
                    style={{
                        padding: "35px 28px",
                        margin: "0px",
                        position: "relative",
                        zIndex: "30",
                           

                        marginLeft: "0px",
                        marginRight: "0px",
                    }}
                >
                    <div className="col">
                        <button
                            className="btn BackImga"
                            onClick={(e) => {
                                navigate("/employment");
                            }}
                        >
                            <img className="PreviousPages" src={BackImage} />
                            <span></span>

                        </button>
                    </div>
                </div>



                <div
                    id="printableDiv"
                    // className={`NoDUEFORMS_FLEX ${printing && "a4Div"}`}
                    className="NoDUEFORMS_FLEX"
                    ref={divRef}
                    style={{ width: "100%" }}
                >
                    <div
                        className="InnerDueForm"
                        style={{ padding: "15px", border: "1px solid black" }}
                    >
                        <div style={{ margin: "0 30px 0 30px", backgroundColor: "white" }}>
                            <div className="row NodueForm">
                                {/* -------No--due---Header----- */}
                                <div
                                    className="col-12 text-center HeaderForm"
                                    style={{
                                        borderTop: "1px solid lightgrey",
                                        borderRight: "1px solid lightgrey",
                                        borderLeft: "1px solid lightgrey",
                                    }}
                                >
                                    <h3>NO DUE FORM</h3>
                                </div>
                                {/* -------No--due--Column-Header--and--Input Fields-- 1- */}
                                <div className="col columns flexLeft">
                                    <span>Name of Employee </span>
                                </div>
                                <div className="col-sm-4 columns flexLeft">
                                    {/* -----input----Field---- */}
                                    <input className="InputFieldDue" name="first_name"
                                        readOnly
                                        value={state.NodueFormFetchDatasgetFetch.noduformfetchdatasemp?.first_name}
                                    // onChange={LanguageChange}
                                    />
                                    {/* <p>
                                        {
                                            state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas?.user_id
                                                ?.first_name
                                        }
                                        {
                                            state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas?.user_id
                                                ?.last_name
                                        }
                                    </p> */}
                                </div>
                                <div className="col columns">
                                    <span> Employee Code </span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <input className="InputFieldDue" name="emp_code"
                                        readOnly
                                        value={state.NodueFormFetchDatasgetFetch.noduformfetchdatasemp?.employee_code}

                                    />
                                    {/* <p>{state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas?.user_uid}</p> */}
                                </div>
                            </div>

                            {/* -------22------------------------------------- */}

                            {/* <div className="row SecondRow"> */}
                            {/* -------No--due--Column-Header--and--Input Fields---2- */}
                            {/* <div className="col columns Destination">
                                    <span>Designation </span>
                                </div> */}
                            {/* <div className="col-sm-4 columns"> */}
                            {/* -----input----Field---- */}
                            {/* <input className="InputFieldDue" 
                                     onChange={LanguageChange}
                                    /> */}
                            {/* <p>
                                        {
                                            state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas?.user_id
                                                ?.user_role?.role
                                        }
                                    </p> */}
                            {/* </div> */}
                            {/* <div className="col columns Destination">
                                    <span> Location </span>
                                </div>
                                <div className="col-sm-4 columns"> */}
                            {/* <p>{state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas?.location}</p> */}
                            {/* <input className="InputFieldDue" value={Datas.location}  name="location" onChange={LanguageChange}  /> */}
                            {/* </div> */}
                            {/* </div> */}
                            {/* -------33------------------------------------- */}
                            <div className="row ThirdRrow">
                                {/* -------No--due--Column-Header--and--Input Fields---2- */}
                                <div className="col columns ">
                                    <span>Department </span>
                                </div>
                                <div className="col-sm-4 columns">
                                    {/* -----input----Field---- */}
                                    <input className="InputFieldDue" name="department"

                                        readOnly
                                        value={state.NodueFormFetchDatasgetFetch.noduformfetchdatasemp?.designation}

                                    />
                                    {/* <p>{state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas?.department}</p> */}
                                </div>
                                <div className="col columns ">
                                    <span> Date of Joining </span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <input className="InputFieldDue" name="joining_date"


                                        readOnly
                                        value={state.NodueFormFetchDatasgetFetch.noduformfetchdatasemp?.date_of_joining}

                                    />
                                    {/* <p>
                                        {
                                            state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas?.user_id
                                                ?.joining_date
                                        }
                                    </p> */}
                                </div>
                            </div>
                            {/* -------44------------------------------------- */}

                            <div className="row FouthRow">
                                {/* -------No--due--Column-Header--and--Input Fields---2- */}
                                <div className="col columns ">
                                    <span>Official Email id </span>
                                </div>
                                <div className="col-sm-4 columns">
                                    {/* -----input----Field---- */}
                                    <input
                                        className="InputFieldDue"
                                        value={Datas.official_email}
                                        onChange={LanguageChange}

                                    />
                                </div>
                                <div className="col columns ">
                                    <span> Date of Relieving 
                                    </span>
                                    <small className="Error" style={{marginLeft:"-8px",top:"3px",position:"absolute"}}>*</small>

                                </div>
                                <div className="col-sm-4 columns">
                                    <input
                                        className="InputFieldDue"
                                        onChange={LanguageChange}
                                        value={Datas.date_of_relieving}
                                        name="date_of_relieving"
                                        required
                                        type="date"
                                    />
                                </div>
                            </div>
                            {/* -------55------------------------------------- */}
                            <div className="row SecondRow">
                                {/* -------No--due--Column-Header--and--Input Fields---2- */}
                                <div className="col columns Destination">
                                    <span>Personal Contact Number </span>
                                </div>
                                <div className="col-sm-4 columns">
                                    {/* -----input----Field---- */}
                                    <input className="InputFieldDue" name="phone_number"

                                        readOnly
                                        value={state.NodueFormFetchDatasgetFetch.noduformfetchdatasemp?.phone_number}

                                    />
                                    {/* <p>
                                        {
                                            state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas?.user_id
                                                ?.phone_number
                                        }
                                    </p> */}
                                </div>
                                <div className="col columns Destination">
                                    <span> Personal Email Id </span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <input className="InputFieldDue" name="email"


                                        readOnly
                                        value={state.NodueFormFetchDatasgetFetch.noduformfetchdatasemp?.email_id}

                                    />
                                    {/* <p>
                                        {state.NodueFormEmployeeSLiceRetrieveData.NodueFormEmployeeFormRetrirveDatas?.user_id?.email}
                                    </p> */}
                                </div>
                            </div>

                            {/* ..........................DEPARTMENT Details--------------------------- */}

                            <div className="row DepartmentDetails Headers ">
                                <div className="col columns">
                                    <span>DEPARTMENT </span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <span>CHECKLIST</span>
                                </div>
                                <div className="col columns">
                                    <span> REMARKS </span>
                                </div>
                                {/* <div className="col-sm-4 columns">
                                    <span>SIGNATURE</span>
                                </div> */}
                            </div>

                            {/* -------------Inner---Departments--------------------------------- */}
                            {/* .......Check---List............................ */}
                            {/* ------1------------------------------------- */}
                            <div className="row DepartmentDetails ">
                                <div className="col columns InnerDepHeader">
                                    <span style={{ paddingLeft: "2px" }}>
                                        Dept Head/ Reporting Manager{" "}
                                    </span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <span>Knowledge Transfer</span>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <span>Back up</span>
                                        </div>
                                        <div className="col-12 ">
                                            <span>
                                                Clearance for short payments/deductions/outstanding
                                                ifany
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">

                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="kt"
                                                selected={Datas.kt}
                                                value={Datas.kt}
                                            // value="No"
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        /// value={Datas.kt}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="back_up"
                                                selected={Datas.back_up}
                                                value={Datas.back_up}
                                            // value="No"
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        /// value={Datas.kt}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="clearance"
                                                selected={Datas.clearance}
                                                value={Datas.clearance}
                                            // value="No"
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        /// value={Datas.kt}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* .......SIGNATURE............................ */}
                                {/* <div className="col-sm-4 columns">
                                    <span></span>
                                </div> */}
                            </div>

                            {/* -------22------------------------------------- */}

                            <div className="row DepartmentDetails ">
                                <div className="col columns InnerDepHeader">
                                    <span style={{ paddingLeft: "2px" }}>Payroll </span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <span>Salary Advance</span>
                                        </div>
                                        <div className="col-12 ">
                                            <span>Any other advance</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="salary_advance"
                                                value={Datas.salary_advance}
                                                selected={Datas.salary_advance}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                        selected={Datas.clearance}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 ">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="other_advance"
                                                value={Datas.other_advance}
                                                selected={Datas.other_advance}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* .......SIGNATURE............................ */}
                                {/* <div className="col-sm-4 columns">
                                    <span></span>
                                </div> */}
                            </div>

                            {/* -------33------------------------------------- */}
                            <div className="row DepartmentDetails ">
                                <div className="col columns InnerDepHeader">
                                    <span style={{ paddingLeft: "2px" }}>Finance</span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <span>Petty cash advances</span>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <span>Settlement of expenses</span>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <span>Submission of IT Documents</span>
                                        </div>
                                        <div className="col-12">
                                            <span>Happy Account Closure</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="petty_cash"
                                                value={Datas.petty_cash}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                value={Datas.settle_expenses}
                                                name="settle_expenses"
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="it_doc"
                                                value={Datas.it_doc}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="happy_account"
                                            value={Datas.happy_account}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        // value={option.value}
                                                        // value={Datas.happy_account}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* .......SIGNATURE............................ */}
                                {/* <div className="col-sm-4 columns">
                                    <span></span>
                                </div> */}
                            </div>

                            {/* -------44------------------------------------- */}
                            <div className="row DepartmentDetails ">
                                <div className="col columns InnerDepHeader">
                                    <span style={{ paddingLeft: "2px" }}>IT</span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <span>Laptop</span>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <span>Data card & Accessories</span>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <span>SAP Login Id's</span>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <span>Email Id</span>
                                        </div>
                                        <div className="col-12 ">
                                            <span> Login Id's</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="laptop"
                                                value={Datas.laptop}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="card_accessories"
                                                value={Datas.card_accessories}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="sap_login"
                                                value={Datas.sap_login}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="email_id"
                                                value={Datas.email_id}
                                            >
                                              {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 ">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="login_id"
                                                value={Datas.login_id}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* .......SIGNATURE............................ */}
                                {/* <div className="col-sm-4 columns">
                                    <span></span>
                                </div> */}
                            </div>
                            {/* -------55------------------------------------- */}
                            <div className="row DepartmentDetails ">
                                <div className="col columns InnerDepHeader">
                                    <span style={{ paddingLeft: "2px" }}>Admin</span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <span>ID Card & Access Card</span>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <span>Draw Keys</span>
                                        </div>
                                        <div className="col-12">
                                            <span>Business Card</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                value={Datas.id_access_card}
                                                name="id_access_card"
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="draw_key"
                                                value={Datas.draw_key}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="business_card"
                                                value={Datas.business_card}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* .......SIGNATURE............................ */}
                                {/* <div className="col-sm-4 columns">
                                    <span></span>
                                </div> */}
                            </div>

                            {/* -------55------------------------------------- */}
                            <div className="row DepartmentDetails ">
                                <div className="col columns InnerDepHeader">
                                    <span style={{ paddingLeft: "2px" }}>Purchase</span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12">
                                            <span>Blackberry / Phone handset</span>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <span>Sim Card</span>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <span>Stationary Items</span>
                                        </div>
                                        <div className="col-12">
                                            <span>Charger & Datacable</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="headset"
                                                value={Datas.headset}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="sim"
                                                value={Datas.sim}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="stationary_items"
                                                value={Datas.stationary_items}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-12">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="charger_cable"
                                                value={Datas.charger_cable}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* .......SIGNATURE............................ */}
                                {/* <div className="col-sm-4 columns">
                                    <span></span>
                                </div> */}
                            </div>

                            {/* ---------------------6----------------------- */}
                            <div className="row DepartmentDetails ">
                                <div className="col columns InnerDepHeader">
                                    <span style={{ paddingLeft: "2px" }}>Mediclaim </span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 ">
                                            <span style={{ padding: " 10px 2px" }}>Mediclaim</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                    height: "44px",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="medical_claim"
                                                value={Datas.medical_claim}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* .......SIGNATURE............................ */}
                                {/* <div className="col-sm-4 columns">
                                    <span></span>
                                </div> */}
                            </div>

                            {/* ---------------------7----------------------- */}
                            <div className="row DepartmentDetails ">
                                <div className="col columns InnerDepHeader">
                                    <span style={{ paddingLeft: "2px" }}>HR</span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <span>Exit Interview</span>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <span>Resignation Mail / Copy</span>
                                        </div>
                                        <div className="col-12" style={{ padding: "3px" }}>
                                            <span>Notice Period served</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col columns borderBottomClass">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                value={Datas.exit_interview}
                                                name="exit_interview"
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        {/* <div className="row InnerDoubleInputFields"> */}
                                        <div className="col-12 borderBottomClass">
                                            {/* <input className="InputFieldDue" /> */}
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                value={Datas.resign_mail}
                                                name="resign_mail"
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 ">
                                            {/* <input className="InputFieldDue" /> */}
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                value={Datas.notice_period}
                                                name="notice_period"
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        {/* </div> */}

                                        {/* <div className="col-12" style={{ padding: "3px" }}>
                    <input className="InputFieldDue" />
                  </div> */}
                                    </div>
                                </div>
                                {/* .......SIGNATURE............................ */}
                                {/* <div className="col-sm-4 columns">
                                    <span></span>
                                </div> */}
                            </div>

                            {/* ------------------8------------------------- */}
                            <div className="row DepartmentDetails ">
                                <div className="col columns InnerDepHeader">
                                    <span style={{ paddingLeft: "2px" }}>Operations</span>
                                </div>
                                <div className="col-sm-4 columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <span>Relevant Correspondence</span>
                                        </div>
                                        <div
                                            className="col-12 borderBottomClass"
                                            style={{ padding: "13px 2px " }}
                                        >
                                            <span>Uniform / shoes or any othercompany property</span>
                                        </div>
                                        <div className="col-12" style={{ padding: "5px" }}>
                                            <span>Any other handover</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col columns">
                                    <div className="row InnerHeaderOfChecklist">
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="relevant"
                                                value={Datas.relevant}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 borderBottomClass">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                    padding: "16px 0px",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                name="company_property"
                                                value={Datas.company_property}
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12 ">
                                            <select
                                                style={{
                                                    width: "100%",
                                                    border: "0px ",
                                                    background: "none",
                                                    padding: "6.5px 0px",
                                                }}
                                                onChange={LanguageChange}
                                                id="selectbox1"
                                                value={Datas.other_handover}
                                                name="other_handover"
                                            >
                                                {Options.map((option) => (
                                                    <option
                                                        className="Options"
                                                        key={option.id}
                                                        value={option.value}
                                                    >
                                                        {option.lable}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <div className="col-12" style={{ display: "flex", justifyContent: "end", width: "92%", marginTop: "20px" }}>
                    <button className="ButttonCSS btn"
                        style={{ marginBottom: "20px", background: "#234492", color: "white" }}
                        onClick={handleSubmitChanges}
                    >
                        Submit
                    </button>
                </div>
            </div>


        </>)
}

export default NoDueEMP